<template>
  <div id="container" class="container">
    <div class="row">
      <div id="content-area" class="col-sm-9">
        <slot v-bind:itemInfoChanged="itemInfo"></slot>
      </div>
      <div class="col-sm-3 text-light">
        <MeetingCameraSetting :type="type"/>
        <div class="position-relative" v-if="itemInfo">
          <BButton class="mt-2 position-absolute" variant="light" @click="toggleTable" style="right: 10px;">
            <i class="bi bi-x" v-if="tableShow"></i>
            <i class="bi bi-list" v-else></i>
          </BButton>
        </div>
        <div class="table-scroll" v-if="tableShow && itemInfo" style="margin-bottom: 1rem;">
          <table class="table table-bordered table-sm meeting-table mt-5" style="min-width: 400px; margin-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 50px">大区分</th>
                <th v-if="inputFlg && !singleFlg" colspan="2">商品名</th>
                <th v-else style="width: 100px">商品名</th>
                <th style="width: 30px">数量</th>
                <th style="width: 100px">備考</th>
              </tr>
            </thead>
            <tbody v-for="(items, category) in itemInfo" :key="category">
              <tr v-for="(item, index) in items" :key="index">
                <td class="align-middle text-start" :rowspan="Object.keys(items).length" v-if="index === 0" style="width:17%;">{{category}}</td>
                <td v-if="inputFlg && !singleFlg" class="align-middle text-start" style="width:3%"><input type="checkbox" v-model="item['checked']"></td>
                <td v-if="inputFlg && !singleFlg" class="align-middle text-start" style="width:30%;">{{item['itemName']}}<br>¥&nbsp;<input type="text" class="input-product-selection-price" v-model="item['itemPriceRaw']" @blur="sendSignalingInputData($event, index)" :id="'productSelectionPrice'+index" :name="category"></td>
                <td v-else-if="inputFlg" class="align-middle text-start">{{item['itemName']}}<br>¥&nbsp;<input type="text" class="input-product-selection-price" v-model="item['itemPriceRaw']" @blur="sendSignalingInputData($event, index)" :id="'productSelectionPrice'+index" :name="category"></td>
                <td v-else class="align-middle text-start">{{item['itemName']}}<br>{{item['itemPrice']}}</td>
                <td v-if="inputFlg" class="align-middle text-end"><input type="text" class="input-product-selection-quantity" v-model="item['quantity']" @blur="sendSignalingInputData($event, index)" :id="'productSelectionQuantity'+index" :name="category"></td>
                <td v-else class="align-middle text-end">{{item['quantityDef']}}</td>
                <td v-if="inputFlg" class="align-middle text-start"><textarea type="text" class="input-product-selection-remarks" v-model="item['itemRemarks']" @blur="sendSignalingInputData($event, index)" :id="'productSelectionRemarks'+index" :name="category" maxlength="50"></textarea></td>
                <td v-else class="align-middle text-start" style="white-space:pre-wrap;">{{item['itemRemarksDef']}}</td>
              </tr>
              <tr class="tr-total" v-if="getIsTotalShow()">
                <td>{{category.replace('テーブル', '')}}<br>合計</td>
                <td v-if="inputFlg" class="text-end" :colspan="2">{{putTotalPriceRaw(items)}}</td>
                <td v-else class="text-end" :colspan="2">{{putTotalPrice(items)}}</td>
                <td :colspan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeetingCameraSetting from '@/components/MeetingCameraSetting'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import fstore from '@/store/florist-store'
export default {
  name: 'MeetingLayout',
  components: { MeetingCameraSetting },
  props: {
    'type': Number,
    'itemInfo': Object,
    'inputFlg': Boolean,
    'singleFlg': Boolean
  },
  data () {
    return {
      tableShow: true
    }
  },
  methods: {
    toggleTable () {
      if (this.tableShow === true) {
        this.tableShow = false
      } else {
        this.tableShow = true
      }
    },
    putTotalPrice (items) {
      let totalPrice = 0
      for (const item of items) {
        const priceStr = String(item['itemPrice'])
        const quantityStr = String(item['quantityDef'])
        let price = 0
        if (priceStr.length !== 0) {
          price = Number(priceStr.replace(/¥|,/g, ''))
        }
        let quantity = 0
        if (quantityStr.length !== 0) {
          quantity = Number(quantityStr.replace(/¥|,/g, ''))
        }
        totalPrice += price * quantity
      }
      totalPrice = totalPrice.toLocaleString()
      return '¥' + totalPrice
    },
    putTotalPriceRaw (items) {
      let totalPrice = 0
      for (const item of items) {
        const priceStr = item['itemPriceRaw']
        let price = 0
        if (priceStr.length !== 0) {
          price = Number(priceStr)
        }
        const quantityStr = item['quantity']
        let quantity = 0
        if (quantityStr.length !== 0) {
          quantity = Number(quantityStr)
        }
        totalPrice += price * quantity
      }
      totalPrice = totalPrice.toLocaleString()
      return '¥' + totalPrice
    },
    getIsTotalShow () {
      if (JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'] === undefined) {
        fstore.commit('totalShow', false)
        SignalingModel.sendApiEvent('totalShow', this, {'totalShow': false})
        return false
      } else {
        fstore.commit('totalShow', JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'cordinate' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'main' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'guest')
        SignalingModel.sendApiEvent('totalShow', this, {'totalShow': JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'cordinate' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'main' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'guest'})
        return JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'cordinate' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'main' || JSON.parse(localStorage.getItem('suggestionData'))['suggestionType'][0] === 'guest'
      }
    },
    sendSignalingInputData: async function (e, index) {
      try {
        let sendData = {'id': e.target.id, 'categorySerialNumber': index, 'category': e.target.name, 'value': e.target.value}
        SignalingModel.sendInputEvent(this, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  mounted () {
    if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
      document.getElementById('container').style.paddingTop = '65px'
    }
  }
}
</script>
<style>
.tr-total {
  font-weight: 700;
},
.table-scroll {
  overflow-x: scroll;
}
</style>
